/**
 * Blob component
 * --------------
 */

/* Imports */

import React, { useRef, useLayoutEffect } from "react";
import parse from "html-react-parser";
import globals from "../../base/variables";
import { Blob, BlobMain, BlobHover } from "./styles.module.scss";

/* Variables */

const types = {
  b1: {
    path:
      "M0.437099 15.9819C0.985972 12.7434 3.9572 4.18045 14.375 0.825702C16.9748 -0.0114974 22.326 -0.794148 27.9062 1.5913C32.9471 3.7462 38.8125 3.87256 44.4688 3.06005C57.4656 1.19309 77.6875 7.68506 87.0625 27.1226C91.3487 36.0094 91.4995 40.8726 91.4995 51.482C91.4995 71.0445 91.5466 64.2959 91.4995 78.6069C91.4688 87.9375 98.0529 89.9906 99.6875 100.062C100.703 106.32 99.1148 112.996 96.0625 117.344C91.938 123.219 86.2695 127.979 77.082 128C63.5625 128.031 61.625 124.688 56.2812 119.844C50.3215 114.442 47.413 119.079 33.1875 114.094C23.3295 110.639 15.875 103.125 11.875 96.9688C7.875 90.8125 5.03847 81.9688 5.03847 75.0835C5.03847 57.2085 5.03881 50.5757 5.03881 39.6773C5.03881 28.7788 -1.73442 28.7944 0.437099 15.9819Z",
    anim:
      "M49.9842 0C64.4998 0 66.7187 5.875 79.0624 5.875C81.4528 5.875 85.7602 5.1684 90.6249 7.78125C94.0034 9.59585 96.9769 12.4836 98.539 16.2344C101.224 22.6814 100.062 28.8906 96.2812 34.0938C95.0257 35.8213 91.3124 42.7499 91.3124 51.875C91.3124 71.4375 91.3124 64.6889 91.3124 79C91.3124 94.4375 81.5764 106.081 75.1246 110.875C61.4996 121 51.2183 118.594 45.9686 119.406C40.1312 120.31 37.4696 126.945 28.4608 127.789C17.5482 128.812 10.2448 126.142 4.20254 117.703C0.116391 111.996 -1.1875 103.633 1.17195 96.625C2.17937 93.2281 4.39239 90.1706 6.01562 87.9688C7.59375 85.8281 8.65576 83.2165 8.65576 79.4062C8.65576 61.5312 8.6561 52.5 8.6561 39C8.6561 25.5 21.4998 0 49.9842 0Z",
  },
  b2: {
    path:
      "M26.0938 0.00740986C39.0347 0.299871 42.8556 8.5 46.0312 9.53813C50.1358 10.8799 55.0938 8.53818 67.4062 14.6316C78.4282 20.0863 84.0897 30.0478 86.25 35.4741C88.875 42.0675 89.4411 48.1942 89.2188 55.0042C88.9965 61.8142 93.2812 64.8474 95.0938 66.7223C96.1078 67.7712 100 72.3157 100 79.2528C100 90.1272 92.5 94.3144 90.5312 96.2831C84.7188 102.095 87.25 103.189 81.875 110.501C76.2182 118.196 70 122.188 65.375 124.25C62.1991 125.666 56.8125 128 48.25 128C29.875 128 8.03125 113.376 8.03125 87.1274C8.03125 80.7527 8.03125 79.6591 8.03125 64.3162C8.03125 48.9733 8.51616 49.5951 6.96875 44.3954C5.42134 39.1957 0 37.0725 0 25.3497C0 13.6269 9.5 -0.367604 26.0938 0.00740986Z",
    anim:
      "M11.0938 25.4687C14.7255 15.5535 27.2501 0 48.1563 0C62.6251 0 71.586 6.46094 76.711 11.3359C85.8946 20.0716 85.6776 27.365 90.0938 31.1875C93.7507 34.3527 99.9998 38.0938 99.9998 48.5C99.9998 58.9062 93.2648 62.0901 91.2188 65.5C89.4569 68.4366 89.2188 68.7188 89.2188 77.9531C89.2188 89.25 83.7304 97.9679 81.9376 100.5C75.8749 109.063 70.0625 111.969 65.9375 114.062C59.4448 117.358 52.093 117.928 48.5625 118C46.0922 118.051 44.9809 118.731 42.5938 121.031C37.4688 125.969 31.1875 128 25.2812 128C11.0625 128 0 116.219 0 102.719C0 89.2188 7.6875 88.1562 8.06313 77.9687C8.06975 77.7892 8.06255 53.3438 8.06255 43.4688C8.06255 33.5938 9.12505 30.8437 11.0938 25.4687Z",
  },
  b3: {
    path:
      "M49.9842 0C64.4998 0 66.7187 5.875 79.0624 5.875C81.4528 5.875 85.7602 5.1684 90.6249 7.78125C94.0034 9.59585 96.9769 12.4836 98.539 16.2344C101.224 22.6814 100.062 28.8906 96.2812 34.0938C95.0257 35.8213 91.3124 42.7499 91.3124 51.875C91.3124 71.4375 91.3124 64.6889 91.3124 79C91.3124 94.4375 81.5764 106.081 75.1246 110.875C61.4996 121 51.2183 118.594 45.9686 119.406C40.1312 120.31 37.4696 126.945 28.4608 127.789C17.5482 128.812 10.2448 126.142 4.20254 117.703C0.116391 111.996 -1.1875 103.633 1.17195 96.625C2.17937 93.2281 4.39239 90.1706 6.01562 87.9688C7.59375 85.8281 8.65576 83.2165 8.65576 79.4062C8.65576 61.5312 8.6561 52.5 8.6561 39C8.6561 25.5 21.4998 0 49.9842 0Z",
    anim:
      "M0 24.2969C0 12.1562 9.8125 0 24.0078 0C26.8205 0 33.5312 0.312488 40.0078 5.7539C43.5027 8.69021 47.4375 9.10936 51.1094 9.03124C63.3741 8.77029 79.0022 16.7741 86.3281 30.5469C90.625 38.625 91.2969 44.875 91.2969 49.9063C91.2969 69.4688 91.2787 76.5941 91.2969 77.0312C91.9688 93.2188 100 94.875 100 104.531C100 110.781 97.2954 115.446 93.5 118.406C87.25 123.281 82.3118 122.053 78.7812 122.125C66.5625 122.375 63.9688 128 50 128C42.9816 128 36.879 126.539 30.0625 122.891C19.4015 117.184 13.2268 107.659 10.4996 99C7.77241 90.3411 8.68027 85 8.68027 75C8.68027 57.125 8.67969 58.0625 8.67969 48.5C8.67969 38.9375 0 37.8125 0 24.2969Z",
  },
  b4: {
    path:
      "M11.0938 25.4687C14.7255 15.5535 27.2501 0 48.1563 0C62.6251 0 71.586 6.46094 76.711 11.3359C85.8946 20.0716 85.6776 27.365 90.0938 31.1875C93.7507 34.3527 99.9998 38.0938 99.9998 48.5C99.9998 58.9062 93.2648 62.0901 91.2188 65.5C89.4569 68.4366 89.2188 68.7188 89.2188 77.9531C89.2188 89.25 83.7304 97.9679 81.9376 100.5C75.8749 109.063 70.0625 111.969 65.9375 114.062C59.4448 117.358 52.093 117.928 48.5625 118C46.0922 118.051 44.9809 118.731 42.5938 121.031C37.4688 125.969 31.1875 128 25.2812 128C11.0625 128 0 116.219 0 102.719C0 89.2188 7.6875 88.1562 8.06313 77.9687C8.06975 77.7892 8.06255 53.3438 8.06255 43.4688C8.06255 33.5938 9.12505 30.8437 11.0938 25.4687Z",
    anim:
      "M26.0938 0.00740986C39.0347 0.299871 42.8556 8.5 46.0312 9.53813C50.1358 10.8799 55.0938 8.53818 67.4062 14.6316C78.4282 20.0863 84.0897 30.0478 86.25 35.4741C88.875 42.0675 89.4411 48.1942 89.2188 55.0042C88.9965 61.8142 93.2812 64.8474 95.0938 66.7223C96.1078 67.7712 100 72.3157 100 79.2528C100 90.1272 92.5 94.3144 90.5312 96.2831C84.7188 102.095 87.25 103.189 81.875 110.501C76.2182 118.196 70 122.188 65.375 124.25C62.1991 125.666 56.8125 128 48.25 128C29.875 128 8.03125 113.376 8.03125 87.1274C8.03125 80.7527 8.03125 79.6591 8.03125 64.3162C8.03125 48.9733 8.51616 49.5951 6.96875 44.3954C5.42134 39.1957 0 37.0725 0 25.3497C0 13.6269 9.5 -0.367604 26.0938 0.00740986Z",
  },
  b5: {
    path:
      "M0 24.2969C0 12.1562 9.8125 0 24.0078 0C26.8205 0 33.5312 0.312488 40.0078 5.7539C43.5027 8.69021 47.4375 9.10936 51.1094 9.03124C63.3741 8.77029 79.0022 16.7741 86.3281 30.5469C90.625 38.625 91.2969 44.875 91.2969 49.9063C91.2969 69.4688 91.2787 76.5941 91.2969 77.0312C91.9688 93.2188 100 94.875 100 104.531C100 110.781 97.2954 115.446 93.5 118.406C87.25 123.281 82.3118 122.053 78.7812 122.125C66.5625 122.375 63.9688 128 50 128C42.9816 128 36.879 126.539 30.0625 122.891C19.4015 117.184 13.2268 107.659 10.4996 99C7.77241 90.3411 8.68027 85 8.68027 75C8.68027 57.125 8.67969 58.0625 8.67969 48.5C8.67969 38.9375 0 37.8125 0 24.2969Z",
    anim:
      "M11.0938 25.4687C14.7255 15.5535 27.2501 0 48.1563 0C62.6251 0 71.586 6.46094 76.711 11.3359C85.8946 20.0716 85.6776 27.365 90.0938 31.1875C93.7507 34.3527 99.9998 38.0938 99.9998 48.5C99.9998 58.9062 93.2648 62.0901 91.2188 65.5C89.4569 68.4366 89.2188 68.7188 89.2188 77.9531C89.2188 89.25 83.7304 97.9679 81.9376 100.5C75.8749 109.063 70.0625 111.969 65.9375 114.062C59.4448 117.358 52.093 117.928 48.5625 118C46.0922 118.051 44.9809 118.731 42.5938 121.031C37.4688 125.969 31.1875 128 25.2812 128C11.0625 128 0 116.219 0 102.719C0 89.2188 7.6875 88.1562 8.06313 77.9687C8.06975 77.7892 8.06255 53.3438 8.06255 43.4688C8.06255 33.5938 9.12505 30.8437 11.0938 25.4687Z",
  },
};

/* Component */

const BlobComponent = ({
  index = 0,
  id = "",
  type = "b1",
  img = "",
  title = "",
  subtitle = "",
  links = [],
  link = "",
}) => {
  const t = types[type];
  const txId = `sp-${id}`;

  /* Hover animation */

  const hoverEl = useRef(null);
  const animEnterEl = useRef(null);
  const animLeaveEl = useRef(null);

  let anim = "";

  if (link && Object.prototype.hasOwnProperty.call(t, "anim")) {
    anim = (
      <>
        <animate
          ref={animEnterEl}
          attributeName="d"
          to={t.anim}
          dur="550ms"
          fill="freeze"
          begin="none"
        />
        <animate
          ref={animLeaveEl}
          attributeName="d"
          to={t.path}
          dur="550ms"
          fill="freeze"
          begin="none"
        />
      </>
    );
  }

  const hover = (e) => {
    if (!animEnterEl.current || !animLeaveEl.current) return;

    hoverEl.current.setAttribute("data-hovering", "");

    if (e.type === "mouseenter") {
      animEnterEl.current.beginElement();
    } else {
      animLeaveEl.current.beginElement();

      setTimeout(() => {
        hoverEl.current.removeAttribute("data-hovering", "");
      }, 550);
    }
  };

  useLayoutEffect(() => {
    if (link && hoverEl.current && !globals.reduceMotion) {
      // workaround for mouseleave/enter bubbling...
      hoverEl.current.addEventListener("mouseenter", hover);
      hoverEl.current.addEventListener("mouseleave", hover);
    }

    // clean up
    return () => {
      if (link && hoverEl.current && !globals.reduceMotion) {
        hoverEl.current.removeEventListener("mouseenter", hover);
        hoverEl.current.removeEventListener("mouseleave", hover);
      }
    };
  }, []);

  /* Blob */

  const bloby = (
    <>
      <div className={`${Blob} lc-blob`}>
        <div className={`${BlobMain} lc-blob__main`}>
          <svg
            className="lc-scale lc-vis"
            data-spd="s"
            data-sc="m"
            data-delay={index * 25}
          >
            <defs>
              <clipPath
                id={id}
                clipPathUnits="objectBoundingBox"
                transform="scale(0.01, 0.0078125)"
              >
                <path d={t.path}>{anim}</path>
              </clipPath>
            </defs>
            {img ? (
              <switch>
                <foreignObject
                  x="0"
                  y="0"
                  width="100%"
                  height="100%"
                  clipPath={`url(#${id})`}
                >
                  {img}
                </foreignObject>
              </switch>
            ) : (
              <rect
                x="0"
                y="0"
                width="100%"
                height="100%"
                clipPath={`url(#${id})`}
                fill="#DCE2E0"
              />
            )}
          </svg>
        </div>
      </div>
      <div id={txId} className="lc-pad-v-t lc-vis" data-size="xxs" data-v-all>
        <h3 className="lc-brown lc-mb-8 lc-o-h lc-to-purple">
          <div
            className="lc-move-fade-y"
            data-y="25"
            style={{ "--delay": "50ms" }}
          >
            {parse(title)}
          </div>
        </h3>
        <h4 className="lc-h3-xs lc-mb-5 lc-gray-alt lc-to-gray">
          <div className="lc-move-fade-y" style={{ "--delay": "100ms" }}>
            {subtitle}
          </div>
        </h4>
      </div>
    </>
  );

  return (
    <div className="lc-33">
      <div>
        {link ? (
          <a
            ref={hoverEl}
            className={`${BlobHover} lc-hover lc-blob-hover`}
            href={link}
          >
            {bloby}
          </a>
        ) : (
          bloby
        )}
        <div
          className="lc-flex lc-tx lc-links lc-fade lc-vis"
          data-gap="xs"
          data-justify="center"
          data-v-item={`#${txId}`}
          style={{ "--delay": "150ms" }}
        >
          {links.map((l, i) => (
            <div key={`a-${i}`}>
              <a href={l[1]} target="_blank" rel="noreferrer">
                {l[0]}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

/* Export */

export default BlobComponent;
